import { useRef } from 'react';
export function useDebouncedFunction(func, milliseconds) {
    const timeoutIdRef = useRef();
    if (!func) {
        return undefined;
    }
    const debounced = (...args) => {
        return new Promise(resolve => {
            if (timeoutIdRef.current !== undefined) {
                clearTimeout(timeoutIdRef.current);
            }
            timeoutIdRef.current = window.setTimeout(() => {
                resolve(func(...args));
                timeoutIdRef.current = undefined;
            }, milliseconds);
        });
    };
    return debounced;
}
//# sourceMappingURL=useDebouncedFunction.js.map